__turbopack_context__.v({
  "button": "-0iDhq_button",
  "content": "-0iDhq_content",
  "header": "-0iDhq_header",
  "icon": "-0iDhq_icon",
  "root": "-0iDhq_root",
});
